// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.

import React, { useState } from "react";

// @ts-ignore -- SCSS is loaded by the bundler and has no TypeScript declarations.

import "./login.scss";

import { useNavigate } from "react-router-dom";

import { login as loginAPI } from "../../_api/auth.js";

import toast from "react-hot-toast";

import DashboardPreloader from "./DashboardPreloader.tsx";

import { useAuth } from "../../_api/auth.js";

import { useMutation } from "@tanstack/react-query";

// import LOGO from "../../assets/images";

const Log: React.FC = () => {

  const [showPassword, setShowPassword] = useState(false);
  const [isPreloading, setIsPreloading] = useState(false);

  const [rememberMe, setRememberMe] = useState(false);

  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");

  const [loginUserErrors, setloginUserErrors] = useState({

    email: "",

    password: "",

    wrongPassword: "",

  });

  const { login } = useAuth();

  const navigate = useNavigate();

  const mutationLogin = useMutation({

    mutationFn: loginAPI,

    onSuccess: (data) => {

      // console.log(data);

      login(data.token, data.data); // store token in context + session storage

      if (data.token) {

        // Redirect to dashboard or another page

        toast.success("Connexion réussie!", {

          duration: 4000,

          position: "bottom-right",

          style: { background: "green", color: "#fff" },

        });

        setIsPreloading(true);

      } else

        return setloginUserErrors({

          ...loginUserErrors,

          wrongPassword: data.message || " Email ou mot de passe incorrect",

        });

      // toast.error(data.message || "Login failed. Please try again.", {

      //   duration: 4000,

      //   position: "bottom-right",

      //   style: {

      //     background: "red",

      //     color: "#fff",

      //     padding: "10px",

      //     fontSize: "14px",

      //     borderRadius: "5px",

      //   },

      // });

    },

    onError: (error: any) => {

      // console.log(error.code);

      // console.log(error);

      if (error.code === "ERR_NETWORK")

        return toast.error(

          error.response?.data?.message ||

            "Connexion impossible, réessayer plus tard",

          {

            duration: 4000,

            position: "bottom-right",

            style: {

              background: "red",

              color: "#fff",

            },

          },

        );

      if (error.message === "Network Error") {

        return toast.error("Connexion impossible, réessayer plus tard", {

          duration: 4000,

          position: "bottom-right",

          style: {

            background: "red",

            color: "#fff",

          },

        });

      }

    },

  });

  const togglePasswordVisibility = () => {

    setShowPassword(!showPassword);

  };

  const handleSubmit = () => {

    setloginUserErrors({ email: "", password: "", wrongPassword: "" });

    if (!email.trim()) {

      return setloginUserErrors({

        ...loginUserErrors,

        email: "Email est requis",

      });

    }

    if (!password.trim()) {

      return setloginUserErrors({

        ...loginUserErrors,

        password: "Mot de passe est requis",

      });

    }

    mutationLogin.mutate({

      email,

      password,

    });

  };

  return (

    <>

      {isPreloading && <DashboardPreloader onComplete={() => navigate("/", { replace: true })} />}

      <div className="relative min-h-screen overflow-hidden bg-[#E9EEF6]">

        {/* =====================================================

          BACKGROUND

      ====================================================== */}

        <div className="pointer-events-none absolute inset-0">

          {/* Dégradé doux */}

          <div className="absolute inset-0 bg-gradient-to-br from-[#E8EEF8] via-[#DDE7F3] to-[#CFDDF0]" />

          {/* Halo bleu */}

          <div className="absolute -left-40 -top-48 h-[500px] w-[500px] rounded-full bg-blue-300/20 blur-3xl" />

          {/* Halo violet très léger */}

          <div className="absolute -bottom-52 right-[5%] h-[500px] w-[500px] rounded-full bg-indigo-300/20 blur-3xl" />

          {/* Cercle décoratif */}

          <div className="absolute -right-28 -top-32 h-[420px] w-[420px] rounded-full border-[70px] border-white/15" />

          {/* Pattern discret */}

          <div

            className="absolute left-[6%] top-[14%] h-24 w-24 opacity-20"

            style={{

              backgroundImage:

                "radial-gradient(circle, #2563EB 2px, transparent 2px)",

              backgroundSize: "16px 16px",

            }}

          />

        </div>

        {/* =====================================================

          PAGE

      ====================================================== */}

        <div className="relative z-10 flex min-h-screen items-center justify-center px-4 py-6 sm:px-6">

          <div className="grid w-full max-w-[980px] items-center gap-10 lg:grid-cols-[1fr_470px] lg:gap-12">

            {/* =================================================

              LEFT — BRANDING

          ================================================== */}

            <div className="hidden lg:block">

              {/* LOGO */}

              <div className="mb-8">

                <div className="flex items-center gap-4">

                  <div className="flex h-[72px] w-[72px] shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-white/50 bg-blue-500 p-2 shadow-sm backdrop-blur-sm">

                    <img

                      src="/images/chiksoft.png"

                      alt="Chiksoft"

                      className="h-full w-full object-contain"

                    />

                  </div>

                  <div>

                    <h1 className="text-[30px] font-bold leading-none tracking-tight text-[#15213B]">

                      Chiksoft

                    </h1>

                    <p className="mt-2 text-[11px] font-medium text-slate-500">

                      Système de gestion scolaire moderne

                    </p>

                  </div>

                </div>

              </div>

              <div className="mb-5 h-1 w-10 rounded-full bg-blue-600" />

              <h2 className="max-w-[390px] text-[26px] font-semibold leading-[1.3] tracking-tight text-[#17233E]">

                Simplifiez la gestion de votre établissement

              </h2>

              <p className="mt-3 max-w-[420px] text-[12px] leading-6 text-slate-500">

                Centralisez vos opérations scolaires dans un environnement

                simple, fiable et sécurisé.

              </p>

              {/* FEATURES */}

              <div className="mt-7 space-y-3">

                <div className="flex items-center gap-3">

                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/60 text-blue-600 shadow-sm">

                    <i className="fas fa-users text-[10px]" />

                  </div>

                  <span className="text-[11px] font-medium text-slate-600">

                    Élèves, parents et enseignants

                  </span>

                </div>

                <div className="flex items-center gap-3">

                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/60 text-blue-600 shadow-sm">

                    <i className="fas fa-chart-column text-[10px]" />

                  </div>

                  <span className="text-[11px] font-medium text-slate-600">

                    Suivi académique et administratif

                  </span>

                </div>

                <div className="flex items-center gap-3">

                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/60 text-blue-600 shadow-sm">

                    <i className="fas fa-shield-halved text-[10px]" />

                  </div>

                  <span className="text-[11px] font-medium text-slate-600">

                    Gestion sécurisée et centralisée

                  </span>

                </div>

              </div>

            </div>

            {/* =================================================

              RIGHT

          ================================================== */}

            <div className="mx-auto w-full max-w-[470px]">

              {/* MOBILE BRAND */}

              <div className="mb-5 flex items-center justify-center gap-3 lg:hidden">

                <div className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-xl border border-white/60 bg-blue-500 p-1.5 shadow-sm">

                  <img

                    src="/images/chiksoft.png"

                    alt="Chiksoft"

                    className="h-full w-full object-contain"

                  />

                </div>

                <div>

                  <h1 className="text-lg font-bold leading-none text-[#17233E]">

                    Chiksoft

                  </h1>

                  <p className="mt-1 text-[9px] text-slate-500">

                    Gestion scolaire moderne

                  </p>

                </div>

              </div>

              {/* =================================================

                LOGIN CARD

            ================================================== */}

              <div className="overflow-hidden rounded-2xl border border-white/70 bg-white/75 shadow-[0_18px_55px_rgba(50,70,110,0.12)] backdrop-blur-xl">

                <div className="px-6 pt-7 text-center sm:px-8">

                  <div className="relative mx-auto mb-4 flex h-[100px] w-[150px] items-center justify-center">

                    <div className="absolute h-[92px] w-[92px] rounded-full bg-blue-500/[0.06]" />

                    <div className="absolute h-[68px] w-[68px] rounded-full bg-blue-500/[0.07]" />

                    <div className="relative flex h-14 w-14 items-center justify-center rounded-2xl border border-blue-100 bg-white text-blue-600 shadow-sm">

                      <i className="fas fa-lock text-xl" />

                      <div className="absolute -bottom-1.5 -right-1.5 flex h-6 w-6 items-center justify-center rounded-full border-[3px] border-white bg-emerald-500 text-white shadow-sm">

                        <i className="fas fa-check text-[7px]" />

                      </div>

                    </div>

                    <div className="absolute left-0 top-1/2 flex items-center">

                      <div className="h-px w-6 border-t border-dashed border-slate-300" />

                      <div className="flex h-6 w-6 items-center justify-center rounded-lg bg-white/70 text-slate-400 shadow-sm">

                        <i className="fas fa-user text-[8px]" />

                      </div>

                    </div>

                    <div className="absolute right-0 top-1/2 flex items-center">

                      <div className="flex h-6 w-6 items-center justify-center rounded-lg bg-white/70 text-slate-400 shadow-sm">

                        <i className="fas fa-shield-halved text-[8px]" />

                      </div>

                      <div className="h-px w-6 border-t border-dashed border-slate-300" />

                    </div>

                  </div>

                  {/* <span className="inline-flex rounded-full bg-blue-50 px-2.5 py-1 text-[8px] font-semibold uppercase tracking-wider text-blue-600">

                    Espace sécurisé

                  </span> */}

                  <h2 className="mt-2 text-[19px] font-semibold tracking-tight text-[#17233E] sm:text-[21px]">

                    Bienvenue sur Chiksoft

                  </h2>

                  <p className="mx-auto mt-2 max-w-[350px] text-[10px] leading-[1.7] text-slate-500 sm:text-[11px]">

                    Connectez-vous pour accéder à votre espace de gestion

                    scolaire.

                  </p>

                </div>

                {/* HEADER */}

                <div className="hidden items-center gap-3 border-b border-slate-200/60 px-6 py-4">

                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-blue-600/10 text-blue-600">

                    <i className="fas fa-lock text-[10px]" />

                  </div>

                  <div>

                    <h2 className="text-[14px] font-semibold text-[#17233E]">

                      Connexion

                    </h2>

                    <p className="mt-0.5 text-[9px] text-slate-500">

                      Accédez à votre espace Chiksoft

                    </p>

                  </div>

                </div>

                {/* =================================================

                  FORM

              ================================================== */}

                <div className="space-y-4 px-6 py-5 sm:px-8">

                  {/* EMAIL */}

                  <div>

                    <label className="mb-1.5 block text-[10px] font-medium text-slate-600">

                      Adresse email

                    </label>

                    <div className="relative">

                      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3.5">

                        <i

                          className={`fas fa-envelope text-[10px] ${

                            loginUserErrors.email

                              ? "text-red-400"

                              : "text-slate-400"

                          }`}

                        />

                      </div>

                      <input

                        type="email"

                        value={email}

                        onChange={(e) => {

                          setEmail(e.target.value);

                          setloginUserErrors({

                            ...loginUserErrors,

                            email: "",

                          });

                        }}

                        className={`h-10 w-full rounded-lg border bg-white/60 pl-10 pr-3 text-[11px] text-slate-700 outline-none transition placeholder:text-slate-400 ${

                          loginUserErrors.email

                            ? "border-red-300 focus:border-red-400 focus:ring-2 focus:ring-red-500/10"

                            : "border-slate-200 hover:border-slate-300 focus:border-blue-500 focus:bg-white focus:ring-2 focus:ring-blue-500/10"

                        }`}

                        placeholder="Email ou identifiant"

                      />

                    </div>

                    {loginUserErrors.email && (

                      <div className="mt-1 flex items-center gap-1.5 text-[8px] text-red-500">

                        <i className="fas fa-circle-exclamation text-[7px]" />

                        <span>{loginUserErrors.email}</span>

                      </div>

                    )}

                  </div>

                  {/* PASSWORD */}

                  <div>

                    <label className="mb-1.5 block text-[10px] font-medium text-slate-600">

                      Mot de passe

                    </label>

                    <div className="relative">

                      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3.5">

                        <i

                          className={`fas fa-key text-[10px] ${

                            loginUserErrors.password ||

                            loginUserErrors.wrongPassword

                              ? "text-red-400"

                              : "text-slate-400"

                          }`}

                        />

                      </div>

                      <input

                        type={showPassword ? "text" : "password"}

                        value={password}

                        onChange={(e) => {

                          setPassword(e.target.value);

                          setloginUserErrors({

                            ...loginUserErrors,

                            password: "",

                          });

                        }}

                        className={`h-10 w-full rounded-lg border bg-white/60 pl-10 pr-10 text-[11px] text-slate-700 outline-none transition placeholder:text-slate-400 ${

                          loginUserErrors.password ||

                          loginUserErrors.wrongPassword

                            ? "border-red-300 focus:border-red-400 focus:ring-2 focus:ring-red-500/10"

                            : "border-slate-200 hover:border-slate-300 focus:border-blue-500 focus:bg-white focus:ring-2 focus:ring-blue-500/10"

                        }`}

                        placeholder="Mot de passe"

                        required

                      />

                      <button

                        type="button"

                        onClick={togglePasswordVisibility}

                        className="absolute inset-y-0 right-0 flex w-10 items-center justify-center text-slate-400 transition hover:text-slate-600"

                      >

                        <i

                          className={`fas ${

                            showPassword ? "fa-eye-slash" : "fa-eye"

                          } text-[10px]`}

                        />

                      </button>

                    </div>

                    {loginUserErrors.password && (

                      <div className="mt-1 flex items-center gap-1.5 text-[8px] text-red-500">

                        <i className="fas fa-circle-exclamation text-[7px]" />

                        <span>{loginUserErrors.password}</span>

                      </div>

                    )}

                    {loginUserErrors.wrongPassword && (

                      <div className="mt-1 flex items-center gap-1.5 text-[8px] text-red-500">

                        <i className="fas fa-circle-exclamation text-[7px]" />

                        <span>{loginUserErrors.wrongPassword}</span>

                      </div>

                    )}

                  </div>

                  {/* OPTIONS */}

                  <div className="flex items-center justify-between gap-4">

                    <label className="flex cursor-pointer items-center gap-2">

                      <input

                        type="checkbox"

                        checked={rememberMe}

                        onChange={(e) => setRememberMe(e.target.checked)}

                        className="h-3.5 w-3.5 rounded border-slate-300 text-blue-600 focus:ring-blue-500"

                      />

                      <span className="text-[9px] text-slate-500">

                        Se souvenir de moi

                      </span>

                    </label>

                    <span className="cursor-pointer text-[9px] font-medium text-blue-600 transition hover:text-blue-700">

                      Mot de passe oublié ?

                    </span>

                  </div>

                  {/* LOGIN */}

                  <button

                    onClick={handleSubmit}

                    disabled={mutationLogin.isPending}

                    className="group flex h-10 w-full items-center justify-center gap-2 rounded-lg disabled:cursor-not-allowed disabled:opacity-60 bg-blue-600 px-4 text-[10px] font-semibold text-white shadow-[0_5px_15px_rgba(37,99,235,0.18)] transition hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-500/10"

                  >

                    {mutationLogin.isPending ? (
                      <>
                        <i className="fas fa-spinner fa-spin text-[11px]" />
                        <span>Connexion en cours...</span>
                      </>
                    ) : (
                      <>
                        <span>Se connecter</span>
                        <i className="fas fa-arrow-right text-[8px] transition-transform group-hover:translate-x-0.5" />
                      </>
                    )}

                  </button>

                </div>

                {/* FOOTER */}

                <div className="border-t border-slate-200/60 bg-slate-50/50 px-5 py-2.5">

                  <div className="flex items-center justify-center gap-1.5 text-[8px] text-slate-400">

                    <i className="fas fa-shield-halved text-[7px]" />

                    <span>Accès sécurisé à votre espace Chiksoft</span>

                  </div>

                </div>

              </div>

              {/* COPYRIGHT */}

              <div className="mt-4 text-center">

                <p className="text-[8px] text-slate-500">

                  ©{new Date().getFullYear()} Ehula Technologies. Tous droits

                  réservés.

                </p>

              </div>

            </div>

          </div>

        </div>

      </div>

    </>

  );

};

export default Log;
